


















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PostsApi, GetPostResponse } from "../../../apis";
import * as moment from "moment";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class InstructionDetail extends Vue {
  itemsLanguage = ["English", "Tieng Viet"];
  dataInstructionDetail = [];
  headerUrlEn = "";
  headerUrlVn = "";
  subjectEn = "";
  shortDescriptionEn = "";
  contentEn = "";
  subjectVn = "";
  shortDescriptionVn = "";
  contentVn = "";
  language = "";
  createdAt = "";
  updatedAt = "";
  isEn = true;
  isVn = false;
  isECO2 = true;
  showConfirmDialog = false;
  confirmContent = "";
  errDialog = "";
  headerImageHeight = "100%";

  getEdit() {
    const id = this.$route.params.id;
    this.$router.push({ name: "edit-instruction", params: { id } });
  }
  async beforeMount() {
    this.getInstructionDetail();
  }

  instructionResponse: GetPostResponse;
  get currentLocale() {
    return this.$store.getters.locale;
  }

  @Watch("currentLocale")
  onCurrentLocaleWatch() {
    this.getInstructionDetail();
  }

  async getInstructionDetail() {
    if (this.$store.getters.user.organization === "CLIENT") {
      this.isECO2 = false;
    }
    if (this.$store.getters.locale === "vi") {
      this.isEn = false;
      this.isVn = true;
    } else {
      this.isVn = false;
      this.isEn = true;
    }
    this.$util.showLoading();
    try {
      const rs = await new PostsApi().getPost({ id: this.$route.params.id });
      const [instruction] = rs.data.data;
      this.subjectEn = instruction.subjectEn;
      this.headerUrlEn = instruction.headerUrlEn;
      this.shortDescriptionEn = instruction.shortDescriptionEn;
      this.contentEn = instruction.contentEn;

      this.subjectVn = instruction.subjectVn;
      this.headerUrlVn = instruction.headerUrlVn;
      this.shortDescriptionVn = instruction.shortDescriptionVn;
      this.contentVn = instruction.contentVn;

      this.updatedAt = instruction.updatedAt;
      this.updatedAt = moment(this.updatedAt).format("D MMM, YYYY HH:mmA");
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
  async deleteInstruction() {
    this.$util.showLoading();
    const id = this.$route.params.id;
    try {
      const rs = await new PostsApi().deletePost({
        id: id,
      });
    } catch {
    } finally {
      this.$util.hideLoading();
      this.$router.push({ name: "instructions" });
    }
  }
  onCancelDialog() {
    this.errDialog = "";
  }
  onDeleteInstruction() {
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmInstruction.contentDelete"
    )}`;
  }

  onOkConfirmDialog() {
    this.deleteInstruction();
  }

  onLoadImageCompleted(event) {
    const headerImageEle = document.getElementById("header-img");
    if (headerImageEle) {
      this.headerImageHeight = "" + headerImageEle.offsetHeight;
      headerImageEle.classList.add("tw-hidden");
    }
  }
}
